import React from 'react';

/**
 * Card Component
 * 
 * A reusable card component styled according to Zamanat design system
 * 
 * @param {Object} props
 * @param {boolean} props.hover - Whether card has hover effect
 * @param {boolean} props.accent - Whether card has accent styling
 * @param {string} props.className - Additional CSS classes
 * @param {React.ReactNode} props.children - Card content
 */
const Card = ({
  hover = false,
  accent = false,
  className = '',
  children,
  ...props
}) => {
  const classes = [
    'card',
    hover && 'card-hover',
    accent && 'card-accent',
    className,
  ].filter(Boolean).join(' ');
  
  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

/**
 * CardHeader Component
 */
export const CardHeader = ({ className = '', children, ...props }) => (
  <div className={`p-6 border-b border-gray-200 dark:border-[#3A3C3E] ${className}`} {...props}>
    {children}
  </div>
);

/**
 * CardBody Component
 */
export const CardBody = ({ className = '', children, ...props }) => (
  <div className={`p-6 ${className}`} {...props}>
    {children}
  </div>
);

/**
 * CardFooter Component
 */
export const CardFooter = ({ className = '', children, ...props }) => (
  <div className={`p-6 border-t border-gray-200 dark:border-[#3A3C3E] ${className}`} {...props}>
    {children}
  </div>
);

export default Card;

